/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoiceline2Inputs */

const en_ticketsinvoiceline2 = /** @type {(inputs: Ticketsinvoiceline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyers get their invoice by email and can open it in the app.`)
};

const de_ticketsinvoiceline2 = /** @type {(inputs: Ticketsinvoiceline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer bekommen ihre Rechnung per E-Mail und können sie in der App öffnen.`)
};

/**
* | output |
* | --- |
* | "Buyers get their invoice by email and can open it in the app." |
*
* @param {Ticketsinvoiceline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoiceline2 = /** @type {((inputs?: Ticketsinvoiceline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoiceline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoiceline2(inputs)
	return de_ticketsinvoiceline2(inputs)
});
export { ticketsinvoiceline2 as "ticketsInvoiceLine" }